import { Paper, Stack, Typography } from '@mui/material';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import RestHttpClient from '../../../common/RestHttpClient';
import { HeadCell } from '../../../common/table/EnhancedTableHead';
import { EnhancedTable } from '../../../common/table/EnhancedTable';

interface ClassificationGroupObjectLinkRow {
  id: string;
  objectType: string;
  groupName: string;
}

export function GroupObjectList() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data = [], isLoading } = useQuery({
    queryKey: ['classification', 'objects'],
    queryFn: () => RestHttpClient.getClassificationGroupObjects(undefined),
    select: (x) => x.data,
  });

  const headCells: readonly HeadCell<ClassificationGroupObjectLinkRow>[] = [
    {
      id: 'objectType',
      disablePadding: false,
      label: t('classification.classifiedObject.type'),
      allowSorting: true,
      allowFiltering: true,
    },
    {
      id: 'groupName',
      disablePadding: false,
      label: t('classification.classifiedObject.groupName'),
      allowSorting: true,
      allowFiltering: true,
    },
    {
      id: 'id',
      disablePadding: false,
      label: t('classification.classifiedObject.id'),
      allowSorting: true,
      allowFiltering: true,
    },
  ];

  const handleRowClick = (e: React.MouseEvent<unknown>, id: string) => {
    e.stopPropagation();

    const objectLink = data.find((x) => x.objectId === id);
    if (objectLink) {
      navigate(`/classification/objects/${objectLink.objectId}/${objectLink.objectType}`);
    }
  };

  const rows: ClassificationGroupObjectLinkRow[] = data.map((x) => ({
    id: x.objectId,
    groupName: x.groupName,
    objectType: t(`classification.classifiedObject.types.${x.objectType}`),
  }));

  return (
    <Stack gap={2}>
      <Typography variant="h1">{t('classification.classifiedObjectGroup.title')}</Typography>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <EnhancedTable
          rows={rows}
          loading={isLoading}
          headCells={headCells}
          hideCheckbox={true}
          variant="default"
          onRowClick={handleRowClick}
          defaultOrderBy="dummyName"
          defaultOrder="desc"
        />
      </Paper>
    </Stack>
  );
}

export default GroupObjectList;
